/** 배열 쿼리 직렬화 — Spring은 `a=1,2`(comma), FastAPI는 `a=1&a=2`(repeat). 다르게 보내면 422가 난다. */
export type ArrayFormat = 'comma' | 'repeat';

export type QueryValue = string | number | boolean | null | undefined;
export type QueryParams = Record<string, QueryValue | readonly QueryValue[]>;

/** 빈 값(null·undefined·빈 문자열·빈 배열)은 키째 뺀다. */
export function toSearchParams(params: QueryParams, format: ArrayFormat) {
  const search = new URLSearchParams();
  for (const [key, raw] of Object.entries(params)) {
    const values = (Array.isArray(raw) ? raw : [raw]).filter(
      (value): value is string | number | boolean =>
        value !== null && value !== undefined && value !== '',
    );
    if (values.length === 0) {
      continue;
    }
    if (format === 'comma') {
      search.set(key, values.map(String).join(','));
    } else {
      values.forEach((value) => {
        search.append(key, String(value));
      });
    }
  }
  return search;
}
